/**
 * Enum for Channel values.
 * @readonly
 * @enum {string}
 */
export enum EChannel {
  /** Chatbot channel. */
  CHATBOT = 'chatbot',

  /** Mi Claro App channel. */
  MCAPP = 'claroApp',

  /** Mi claro express channel. @default */
  MCE = 'mce',

  /** Mi claro web channel. */
  MCWEB = 'mcw'
}
